import React from 'react';
import Button from '@mui/material/Button';
import { FaCode, FaGlobe, FaGooglePlay } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './Projects.css';

interface ProjectActionButtonsProps {
  /** URL of the public source-code repository (usually GitHub) */
  githubUrl?: string;
  /** URL of the app on the Google Play Store */
  googlePlayUrl?: string;
  /** URL of a public website for the project */
  websiteUrl?: string;
}

/**
 * Retro action buttons for the project dialogs.
 * Each button shows an icon plus a text label so visitors know exactly
 * what the button does (view the code on GitHub, open Google Play, etc.).
 */
const ProjectActionButtons: React.FC<ProjectActionButtonsProps> = ({
  githubUrl,
  googlePlayUrl,
  websiteUrl,
}) => {
  const { t } = useTranslation();

  if (!githubUrl && !googlePlayUrl && !websiteUrl) {
    return null;
  }

  return (
    <div className="button-container project-actions">
      {githubUrl && (
        <Button
          className="project-action"
          href={githubUrl}
          target="_blank"
          rel="noreferrer"
          title={t('projectDialogs.actions.github')}
        >
          <FaCode className="icon" aria-hidden="true" />
          <span className="project-action-label">{t('projectDialogs.actions.github')}</span>
        </Button>
      )}

      {googlePlayUrl && (
        <Button
          className="project-action"
          href={googlePlayUrl}
          target="_blank"
          rel="noreferrer"
          title={t('projectDialogs.actions.googlePlay')}
        >
          <FaGooglePlay className="icon" aria-hidden="true" />
          <span className="project-action-label">{t('projectDialogs.actions.googlePlay')}</span>
        </Button>
      )}

      {websiteUrl && (
        <Button
          className="project-action"
          href={websiteUrl}
          target="_blank"
          rel="noreferrer"
          title={t('projectDialogs.actions.website')}
        >
          <FaGlobe className="icon" aria-hidden="true" />
          <span className="project-action-label">{t('projectDialogs.actions.website')}</span>
        </Button>
      )}
    </div>
  );
};

export default ProjectActionButtons;
